import { Button } from '@change/ds-core-ui/Button';
import { cn } from '@change/ds-utils';

export const ClaimAction: React.FC<ClaimActionProps> = ({
	onClick,
	buttonText,
	className,
	buttonClassName,
	leadingIcon,
}) => {
	return (
		<div className={cn('w-full', className)} data-qa="claim-action">
			<Button
				variant="primary"
				size="large"
				onClick={onClick}
				className={cn('mx-auto w-full max-w-md md:max-w-xs', leadingIcon ? 'flex' : 'block', buttonClassName)}
				leadingIcon={leadingIcon}
				data-qa="claim-petition-button"
			>
				{buttonText}
			</Button>
		</div>
	);
};

type ClaimActionProps = {
	onClick: () => void;
	buttonText: string;
	className?: string;
	buttonClassName?: string;
	leadingIcon?: React.ReactNode;
};
